function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs4"
}, /*#__PURE__*/React.createElement("style", {
  id: "style2"
}, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m 77.77,232.66 c 11.26,-13 55.63,-79.86 70.62,-127.48 A 75.42,75.42 0 1 0 4.26,94.67 v 0 c 0.12,0.5 0.24,1 0.37,1.52 0.13,0.52 0.29,1.21 0.46,1.81 12.39,47.77 60.83,121 72.68,134.66 z",
  id: "path6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m 77.78,232.14 1.89,1.64 c 1.48,-1.72 3.43,-4.22 5.78,-7.42 a 594.7,594.7 0 0 0 33.81,-53 c 12.63,-22.18 24.87,-46.78 31.53,-67.91 l -2.38,-0.75 2.34,0.88 A 77.91,77.91 0 1 0 0,77.91 78.57,78.57 0 0 0 1.83,94.69 l 2.45,-0.53 1.46,-2 v 0 l -5.41,-3.94 1.49,6.49 c 0.12,0.52 0.25,1 0.37,1.55 v 0 c 0.15,0.62 0.31,1.24 0.48,1.88 v 0 c 3.17,12.17 8.57,25.82 15.09,39.7 a 581.38,581.38 0 0 0 33,59.64 c 5.47,8.73 10.61,16.48 15,22.71 4.39,6.23 7.87,10.92 10.2,13.62 l 1.82,2.19 1.89,-2.18 -1.89,-1.64 1.89,-1.64 c -1.4,-1.61 -3.43,-4.22 -5.88,-7.58 A 603.91,603.91 0 0 1 38.16,166.5 C 31.62,154.78 25.28,142.5 19.92,130.61 A 218.36,218.36 0 0 1 7.5,96.85 v 0 C 7.34,96.28 7.2,95.7 7.05,95.1 v 0 C 6.93,94.58 6.8,94.1 6.69,93.6 l -2.43,0.56 -1.47,2 v 0 L 8.12,100 6.72,93.6 a 72.9,72.9 0 1 1 139.35,10.16 v 0.06 0.08 c -7.38,23.46 -22.16,52 -36.48,76.19 -7.16,12.1 -14.21,23.13 -20.15,31.92 -3,4.4 -5.68,8.24 -8,11.37 -2.32,3.13 -4.2,5.57 -5.53,7.1 l 1.89,1.64 1.89,-1.64 z",
  id: "path48"
});

var SvgMediaUpload = function SvgMediaUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 155.81 235.96",
    id: "svg52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2.2637176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "finals"
  }, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m 48.53332,31.486851 h 61.1151 c 8.43823,0 15.27876,6.840539 15.27876,15.278777 v 61.115102 c 0,8.43823 -6.84053,15.27877 -15.27876,15.27877 h -61.1151 c -8.438237,0 -15.278776,-6.84054 -15.278776,-15.27877 V 46.765628 c 0,-8.438238 6.840539,-15.278777 15.278776,-15.278777 z m 0,10.185856 c -2.812746,0 -5.09292,2.280175 -5.09292,5.092921 v 61.115102 c 0,2.81274 2.280174,5.09291 5.09292,5.09291 h 61.1151 c 2.81274,0 5.09291,-2.28017 5.09291,-5.09291 V 46.765628 c 0,-2.812746 -2.28017,-5.092921 -5.09291,-5.092921 z M 71.451479,89.87885 86.730252,56.951469 109.64842,102.7878 H 48.53332 L 63.812096,77.323182 Z M 61.265637,67.137326 c -4.216943,0 -7.639395,-3.422439 -7.639395,-7.639382 0,-4.222038 3.422452,-7.639394 7.639395,-7.639394 4.216942,0 7.639381,3.417356 7.639381,7.639394 0,4.216943 -3.422439,7.639382 -7.639381,7.639382 z",
    id: "path2",
    style: {
      fill: "#ffffff",
      strokeWidth: 5.09293
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMediaUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/media-upload.d86c0b5d.svg";
export { ForwardRef as ReactComponent };